import React, { ReactElement, useEffect } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { models } from 'powerbi-client';
import { getPowerBIData } from '../../store/actions/dashboardAction';

const CostOfCareFinder = (): ReactElement => {
  const dispatch = useDispatch();

  const {
    pbiData,
  } = useSelector((state: RootState): any => state?.dashboard || {});

  useEffect((): void => {
    dispatch(getPowerBIData('CostOfCareFinder', (): void => { }));
  }, []);

  return (
    pbiData ?
      <PowerBIEmbed
        embedConfig={{
          type: 'report',
          id: pbiData?.id,
          embedUrl: pbiData?.embedUrl,
          accessToken: pbiData?.embedToken?.token,
          tokenType: models.TokenType.Embed,
          permissions: models.Permissions.All,
          settings: {
            hideErrors: false,
            filterPaneEnabled: false,
            navContentPaneEnabled: false,
            bookmarksPaneEnabled: false,
            localeSettings: {
              formatLocale: '',
              language: '',
            },
          },
          filters: [],
        }}
        cssClassName={'core-pbi-dashboard'}
      />
      : <React.Fragment />
  );

};

export default CostOfCareFinder;
